import Api from '@/services/api/api/index.js'
import endpoints from './endpoint'

const redirect = args => {
  let params = new URLSearchParams();

  params.append('calendar_id', args.calendar_id);

  return Api.get(endpoints.get('redirect')+'?'+params.toString());
};

export default {
  redirect
};
